import { withFmaSliceSettings, fmaFieldParameters, fmaListingParameter } from './shared.js';

export default {
  label: 'Astigmatic Line Length', group: 'performance',
  description: 'Length and orientation of the astigmatic line image across the field.',
  settingsSchema: withFmaSliceSettings({}),
  parameters: [...fmaFieldParameters, fmaListingParameter],
  coverage: 'Along the X or Y axis of the field. Line length is in lens units, or in milliradians for afocal systems; afocal systems need angular field coordinates. Not supported: oblique slices and two-dimensional maps.',
} as const;
